/*
 * @name: 自定义组件渲染组件
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { Collapse as DesignCollapse, message } from '@whalecloud/fdx';
import { getElementWithChildren } from '@whalecloud/page-builder-core/selectors';
import isEqual from "lodash/isEqual";
import FormItem from '@whalecloud/page-builder-core/components/FormItem';
import DropChild from "@whalecloud/page-builder-core/components/Dnd/DropChild";
import '../index.module.less';

/**
 * @param  {Object} element 当前元素
 * @param  {} value   组件值，如果自定义组件是表单控件，则在使用时Form会传入该参数，组件需要接收
 * @param  {Function} onChange 组件值改变触发的方法，如果自定义组件是表单控件，则在使用时Form会传入该参数，组件需要接收
 */
const CollapseContainer = ({ element, elementStyle, dropElement }) => {
  const { formItemSettings = {}, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  const { bordered = true, ...rest } = formItemSettings;

  return (
    <div
      style={{ paddingBottom: 5 }}
    >
      <FormItem
        id={element.id}
        style={{
          ...elementStyle,
          visibility: visible
        }}
        {...formSettings}
      >
        <DesignCollapse
          style={bordered ? { minHeight: 70, position: 'relative', 'border-bottom': '1px solid #E0E0E0' } : { minHeight: 70 }}
          defaultActiveKey={['0']}
          bordered={bordered}
          className={className}
        >
          {
            element.elements.map((child: any, index: number) => (
              <div key={child?.id} style={{ position: 'relative' }}>
                <DropChild
                  childId={child.id}
                  childType={child.type}
                  type={element.type}
                  id={element.id}
                  index={index}
                  count={element.elements.length}
                  last={index === element.elements.length - 1}
                />
              </div>
            ))
          }
          {/* <DropZone.Below
            type={element.type}
            onDrop={(source: any) => {
              if (source.type !== 'card') {
                message.warn('请添加Card组件！');
                return false;
              }
              dropElement({
                source,
                parentEl: element,
                target: { id: element.id, type: element.type, position: element.elements.length },
              });
              return {};
            }}
          /> */}
        </DesignCollapse>
      </FormItem>
    </div>
  );
};

export default connect<any, any, any>(
  (state, props) => ({
    state,
    element: getElementWithChildren(state, props.elementId)
  }),
  null,
  null,
  { areStatePropsEqual: isEqual }
)(CollapseContainer);
